import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';
import { serializeQueryArgs } from '../serialize-query-args';

export const serviceProviderApiSlice = createApi({
  reducerPath: 'serviceProviderApiSlice',
  baseQuery,
  endpoints: (builder) => ({
    updateServiceProvider: builder.mutation({
      query: ({ apiManager, ...params }) => apiManager.update(params),
    }),
    // Regions only change through the backend's `regions:upsert`, so one read lasts the session.
    getRegionalConfigs: builder.query({
      query: ({ apiManager }) => apiManager.regionalConfigs(),
      transformResponse: (response) => response?.data ?? [],
      keepUnusedDataFor: 60 * 60,
    }),
  }),
  serializeQueryArgs,
});

export const { useUpdateServiceProviderMutation, useGetRegionalConfigsQuery } = serviceProviderApiSlice;
